<template>
  <!--查看-->
  <div>
    <el-form
      :model="formData"
      v-loading="saveLoading"
      ref="extendForm"
      label-width="90px"
      label-position="left"
      class="form-horizontal detail-form paddingTopDetail orderExtendDetail"
    >
      <div class="cnt-block">
        <div class="cnt-title top-title">
          <div class="m-b-16">订单信息</div>
          <div class="top-title-two font-14">
            <span class="form-label">预定人：</span>
            <span class="color-333 m-r-10">{{ detailData.bookerName }}</span>
            <span class="blue-text">{{ detailData.bookerPhone }}</span>
          </div>
        </div>
        <div class="cnt-items">
          <el-row :gutter="10">
            <el-col :span="14">
              <div class="flex">
                <div class="form-label w-90">订单编码：</div>
                <span
                  class="text-ellipsis color-333"
                  :title="detailData.orderCode"
                  >{{ detailData.orderCode }}</span
                >
              </div>
            </el-col>
            <el-col :span="10">
              <div class="flex">
                <div class="form-label w-90">房源名称：</div>
                <span
                  class="text-ellipsis color-333"
                  :title="detailData.roomName"
                  >{{ detailData.roomName }}</span
                >
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="cnt-block cnt-block-blue">
        <div class="cnt-title">续住信息</div>
        <div class="cnt-items">
          <el-form-item label="原预离时间：" class="rowItem oldTimeItem">
            {{ detailData.proposedCheckOutTime }}
          </el-form-item>
          <el-form-item prop="extendNum" label="续住天数：" class="timeItem">
            <el-input-number
              v-model="formData.extendNum"
              :min="0"
              :max="10000"
            />
          </el-form-item>
          <el-form-item prop="extendHour" label="续住小时：" class="dayItem">
            <el-input-number
              v-model="formData.extendHour"
              :min="0"
              :max="23"
            />
          </el-form-item>
          <el-form-item
            label="续住后预离时间："
            class="timeItem"
            label-width="130px"
          >
            {{ formData.proposedCheckOutTime }}
          </el-form-item>
          <price-component
            v-model="formData.orderPrice"
            :showType="'isInput'"
          ></price-component>
        </div>
      </div>

      <div style="text-align: center; padding: 20px; width: 100%">
        <el-button class="submit-btn" @click="handleSave(0)">确定</el-button>
        <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import RichText from "@/components/common/RichText/RichText";
import { mapActions } from "vuex";
import moment from "moment";
import PriceComponent from "./priceComponent.vue";
import commonMixin from './mixin'

export default {
  mixins: [commonMixin],
  components: { RichText, PriceComponent },
  name: "orderCancelModel",
  props: {
    detailModal: {
      type: Boolean,
      default: false,
    },
    detailData: {
      type: Object,
      default: () => ({}),
    },
    detailType: {
      type: String,
      default: "show",
    },
  },
  data() {
    let detailKeys = ["proposedCheckOutTime", "extendNum", "orderPrice", "roomTypeId", "extendHour"];

    let formData = {};
    detailKeys.map((key) => {
      formData[key] = "";
    });
    return {
      showType: "",
      saveLoading: false,
      detailKeys: detailKeys,

      formData: formData,
      oriOrderPrice: 0,
    };
  },
  mounted() {
    this.showType = this.detailType;
  },
  computed: {
    extendObj(){
      return {
        extendNum: this.formData.extendNum,
        extendHour: this.formData.extendHour,
      }
    }
  },
  watch: {
    detailType(val) {
      this.showType = val;
    },
    detailModal: {
      immediate: true,
      handler: function (to) {
        if (to === false) {
          return false;
        }
        this.$nextTick(() => {
          this.$refs.extendForm.resetFields();
          this.initFormData();
        });
      },
    },
    extendObj({extendNum, extendHour}) {
      if (this.formData.proposedCheckOutTime) {
        this.formData.proposedCheckOutTime = moment(
          this.detailData.proposedCheckOutTime
        )
          .add(extendNum, "days")
          .add(extendHour, "hours")
          .format("YYYY-MM-DD HH:mm");
      }
      // this.changeOrderPrice(extendNum, extendHour)
    },
  },
  methods: {
    ...mapActions(["fetchData"]),
    // 更改订单费用
    changeOrderPrice(num, hourNum) {
      let price = this.oriOrderPrice

      let params = {
        startTime: this.detailData.proposedCheckOutTime,
        endTime: this.formData.proposedCheckOutTime,
        nightNum: num,
        hourNum,
        roomTypeId: this.formData.roomTypeId
      }
      for (let key in params) {
        if(["nightNum", "hourNum"].includes(key)){ continue }
        else if (!params[key]) return
      }
      this.getRoomPrice({
        ...params,
        nightNum: params.nightNum || 0,
        hourNum: params.hourNum || 0,
      }, res => {
        this.formData.orderPrice = Number(price) + Number(res)
      })
    },
    // 初始化表单数据
    initFormData() {
      this.detailKeys.map((key) => {
        this.formData[key] = this.detailData[key] ? this.detailData[key] : "";
      });
      this.oriOrderPrice = this.formData.orderPrice
      this.formData.nlkrq_old = this.detailData.nlkrq;
      this.handleSetDay(1);
    },
    // 根据天数设置时间
    handleSetDay(num) {
      this.formData.nlkrq = moment(this.detailData.nlkrq)
        .add(num, "d")
        .format("YYYY-MM-DD");
      this.formData.extendDay = num;
    },
    // 保存与发布
    handleSave(type) {
      this.doSave("extend");
    },
    doSave(type) {
      let url = "SAAS.ORDER_EXTEND";
      let paramData = {
        id: this.detailData.id,
        proposedCheckOutTime: this.formData.proposedCheckOutTime,
        orderPrice: this.formData.orderPrice
      };

      this.fetchData({
        url: url,
        method: "post",
        params: paramData,
        timeout: 0,
        isLoading: false,
        flag: true,
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success(res.msg || "操作成功！");
            this.$emit("submitSuccess");
          } else {
            this.$message.error(res.msg || "操作失败！");
          }
          this.saveLoading = false;
        })
        .catch((err) => {
          this.$message.error("操作失败！");
          this.saveLoading = false;
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    handleCancel() {
      this.$emit("closeModel");
    },
  },
};
</script>

<style lang="less" scoped>
.orderExtendDetail .el-form-item {
  width: 50% !important;
  .el-select {
    width: 100%;
  }
}
.orderExtendDetail .detailContent {
  padding: 0px;
}
.cnt-block {
  width: 100%;
}
.cnt-title {
  font-size: 18px;
  height: 56px;
  line-height: 56px;
  flex: 1;
}
.cnt-items {
  display: flex;
  background: #f5f5f5;
  padding: 18px 30px;
  border-radius: 3px;
  flex-wrap: wrap;
}
.cnt-block-blue {
  margin-bottom: 18px;
}
.cnt-block-blue .cnt-items {
  background: #f1faff;
}

.el-form-item.rowItem {
  width: 100% !important;
}
.el-form-item :deep(.el-form-item__label),
.el-form-item__label {
  font-size: 14px !important;
  color: #959697;
}
.el-form-item--default {
  margin-bottom: 0;
  :deep(.el-form-item__label) {
    font-weight: normal;
    color: #959697;
  }
  :deep(.el-form-item__content) {
    color: #333333;
  }
}
.el-form-item :deep(.el-form-item__content) {
  margin-bottom: 5px;
}

.top-title {
  display: flex;
  width: 100%;
  .top-title-two {
    flex-grow: 1;
    text-align: right;
    padding-right: 15px;
  }
}
.orderExtendDetail .el-form-item.dayItem {
  width: auto !important;
  margin-right: 16px;
  :deep(.el-form-item__label) {
    color: #333;
    width: auto !important;
  }
}
.orderExtendDetail .el-form-item.oldTimeItem {
  :deep(.el-form-item__label) {
    width: auto !important;
  }
}
.el-input-number :deep(.el-input-number__increase) {
  border-left: 1px solid #c0c4cc !important;
}
.el-input-number :deep(.el-input-number__decrease) {
  border-right: 1px solid #c0c4cc !important;
}

.blue-text {
  color: rgb(56, 147, 215);
  line-height: 32px;
}
.text-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.form-label {
  text-align: right;
  color: #8c8c8c;
}
.color-333 {
  color: #333;
}
.flex {
  display: flex;
}
.color-pri {
  color: rgba(0, 192, 192, 1);
}
.flex-bottom {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
</style>

